import useIsNarrowerThan from '@/hooks/useIsNarrowerThan';
import { useNewBiddingConsoleExperiment } from '@/utils/amplitude/experiments/hooks/useNewBiddingConsole.experiment';

/** Legacy console: mobile below this width (historical behavior; changing risks regressions outside the experiment). */
const LEGACY_BIDDING_CONSOLE_MOBILE_MAX_WIDTH_PX = 999;

/** New console experiment: desktop from this width up (Figma / LAAC-1800; aligns with Hammer `smMin` / `desktop`, 769px). */
const NEW_BIDDING_CONSOLE_DESKTOP_MIN_WIDTH_PX = 769;

/**
 * Returns true if the mobile bidding console should be used.
 */
const useShowMobileConsole = () => {
    const hasNewBiddingConsole = useNewBiddingConsoleExperiment();
    return useIsNarrowerThan(
        hasNewBiddingConsole ? NEW_BIDDING_CONSOLE_DESKTOP_MIN_WIDTH_PX : LEGACY_BIDDING_CONSOLE_MOBILE_MAX_WIDTH_PX
    );
};

export default useShowMobileConsole;
